import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { MapContainer, Marker, Popup, TileLayer, useMapEvents } from 'react-leaflet';

function LeafletMapRestricted({
    center =[36.109, -95.895],
}) {


    /**
     * Set the bounds as 5 zoom off the center
     */

    const boundNum = 0.2;
    const bounds = [
        [center[0] - boundNum, center[1] - boundNum],
        [center[0] + boundNum, center[1] + boundNum]
    ];

    // disable all map events
    function MapClickHandler() {
        useMapEvents({
            click: (e) => {
                
            },
            moveend: (e) => {
            }
        });

        return null;
    }




   

    return (
        <MapContainer center={center} zoom={5}
        // no pan
maxBounds={bounds} maxBoundsViscosity={1}
        style={{ height: "70vh", width: "100%" }}
        >
            <TileLayer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    {/* Add a marker at center */}
    <Marker position={center}>
        </Marker>
            <MapClickHandler />
            <Box
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: "2rem",
                    color: "red",
                    zIndex: 1000
                
                }}
            >
                x
            </Box>
            
        </MapContainer>
    );
}

export default LeafletMapRestricted;